//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('currencyExRateHist', {
//        templateUrl: 'views/components/views/currencyExRateHist/currencyExRateHist.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'currencyExRateHistService', function ($stateParams, currencyExRateHistService) {
//            const vm = this;
//            let currencyExRateKeyno = $stateParams.currencyexrate_keyno;

//            vm.model = {
//    			itemsListHistory: []
//            };

//            async function loadHistory() {
//                vm.model.itemsListHistory = await currencyExRateHistService.listHistory({ currencyexrate_keyno: currencyExRateKeyno });
//            }

//            vm.$onInit = function () {
//                loadHistory();
//            }
//        }]
//    });
//})();
